export default {
  // 导出历史
  'EXPORT.HISTORY.TITLE': '导出列表',
  'EXPORT.INFOR.READY': '您的导出已开始。完成后我们会发送电子邮件至{email}',
  'EXPORT.HISTORY.LIST.EXPORT.TIME': '导出时间',
  'EXPORT.HISTORY.LIST.EXPORT.BY': '导出人员',
  'EXPORT.HISTORY.LIST.STATUS.PADDING': '进行中',
  'EXPORT.HISTORY.LIST.STATUS.SUCCESS': '成功',
  'EXPORT.HISTORY.LIST.STATUS.FAILED': '失败',
  'EXPORT.HISTORY.LIST.NUMBER.OF.CONTACTS': '数量',
  'EXPORT.HISTORY.LIST.EXPORT.CONTENT': '导出内容',
  'EXPORT.HISTORY.LIST.EXPORT.CSV': '导出为 CSV',
  'EXPORT.HISTORY.LIST.EXPORT.EXPIRED': '此项导出已过期',
  'EXPORT.HISTORY.LIST.DELETE.TITLE': '确认删除导出历史记录',
  'EXPORT.HISTORY.LIST.DELETE.CONTENT': '导出记录一旦删除，数据将无法下载。',
  'EXPORT.HISTORY.LIST.EXPORT.CONTENT.PLACEHOLDER': '请输入导出内容 ',
  'EXPORT.HISTORY.LIST.EXPORT.FAIL': '导出失败请重试',
};
